module.exports = __webpack_public_path__ + "img/logo.3019c6c9.webp";